import React, { useCallback, useEffect, useState } from "react";

import { ConfigProvider, DatePicker, Modal } from "antd";
import datePickerLocale from "antd/lib/locale/pt_BR";
import moment from "moment";
import { AiOutlineClose } from "react-icons/ai";
import { FaFilter, FaRegCalendarAlt } from "react-icons/fa";
import { MdOutlineDownload } from "react-icons/md";

import { useClient } from "../../hooks/ClientProvider";
import useInvoicev2 from "../../hooks/useInvoicev2";
import { getInvoicePdf } from "../../utils/get-invoice-pdf";
import LoadingElevaty from "../LoadingElevaty";
import { formatCalendarDay } from "../../utils/formatDate";
import * as Style from "./style";
import { DuplicatedInvoicePDFModal } from "../DuplicatedInvoicePDFModal";

const { RangePicker } = DatePicker;

function ModalHistoricoFaturas({ isOpen, onClose }) {
  const { client } = useClient();

  const [rangeDate, setRangeDate] = useState(false);
  const [loadingInvoiceIdPdf, setLoadingInvoiceIdPdf] = useState(undefined);
  const [lastYear, setLastYear] = useState(() => {
    const lastYearDate = new Date();
    lastYearDate.setMonth(lastYearDate.getMonth() + 2);
    lastYearDate.setDate(0);
    lastYearDate.setMonth(lastYearDate.getMonth() - 12);
    return lastYearDate;
  });
  const [today, setToday] = useState(() => {
    const todayDate = new Date();
    todayDate.setMonth(todayDate.getMonth() + 2);
    todayDate.setDate(0);
    return todayDate;
  });

  const changeRangeFatura = (e) => {
    setLastYear(moment(e[0].utc().format("YYYY-MM-DD HH:mm:ss")).toDate());
    setToday(moment(e[1].utc().format("YYYY-MM-DD HH:mm:ss")).toDate());
  };

  const { invoices, loadingInvoice, getData } = useInvoicev2(
    client?.client?.id,
    formatCalendarDay(lastYear),
    formatCalendarDay(today)
  );

  const onGetInvoicePdf = useCallback(
    async (invoiceId, due_date, cpf) => {
      await getInvoicePdf({
        invoiceId,
        initLoadingState: () => setLoadingInvoiceIdPdf(invoiceId),
        finishLoadingState: () => setLoadingInvoiceIdPdf(undefined),
        clientId: client.client.id,
        due_date: due_date && `${due_date[2]}-${due_date[1]}-${due_date[0]}`,
        cpf,
      });
    },
    [client]
  );

  useEffect(() => {
    if (isOpen) {
      getData();
    }
  }, [isOpen]);

  return (
    <Modal
      title="Histórico de faturas"
      visible={isOpen}
      onCancel={() => onClose(false)}
      width={795}
    >
      <Style.WrapperModalHistoricoFaturas>
        <div className="historico-faturas__filter">
          {rangeDate ? (
            <ConfigProvider locale={datePickerLocale}>
              <RangePicker
                defaultValue={[moment(lastYear), moment(today)]}
                format="DD/MM/YYYY"
                onChange={changeRangeFatura}
              />
              <button
                type="button"
                className="filter close"
                onClick={() => setRangeDate(false)}
              >
                <AiOutlineClose />
              </button>
            </ConfigProvider>
          ) : (
            <button
              type="button"
              className="filter"
              onClick={() => setRangeDate(true)}
            >
              <FaFilter />
            </button>
          )}
        </div>

        {loadingInvoice ? (
          <div className="historico-faturas__loading">
            <LoadingElevaty duration="durFast" />
          </div>
        ) : (
          <div className="historico-faturas__table">
            {invoices ? (
              <>
                <div className="historico-faturas__table--header">
                  <div className="historico-faturas__table--header__data">
                    <p>Vencimento</p>
                  </div>
                  <div className="historico-faturas__table--header__local">
                    <p>Valor Total</p>
                  </div>
                  <div className="historico-faturas__table--header__local">
                    <p>Valor Pago</p>
                  </div>
                  <div className="historico-faturas__table--header__local">
                    <p>Saldo devedor</p>
                  </div>
                  <div className="historico-faturas__table--header__real">
                    <p>Ações</p>
                  </div>
                </div>

                <span>
                  {invoices.map((item, index) => {
                    const due_date = item?.dataVencimento?.split("/");
                    const formatted_due_date =
                      due_date &&
                      `${due_date[2]}-${due_date[1]}-${due_date[0]}`;

                    return (
                      <div
                        className={`historico-faturas__table--item  ${
                          index === 0 ? "first" : ""
                        }`}
                        key={Math.random()}
                      >
                        <div className="item-data">
                          <div className="historico-faturas__title-mobile">
                            <span className="title">Vencimento</span>
                          </div>

                          <FaRegCalendarAlt />

                          <p>{item.dataVencimento}</p>
                        </div>
                        <div className="item-dinheiro">
                          <div className="historico-faturas__title-mobile">
                            <span className="title">Valor Total</span>
                          </div>
                          <p>{item.valorTotal}</p>
                        </div>
                        <div className="item-dinheiro">
                          <div className="historico-faturas__title-mobile">
                            <span className="title">Valor Pago</span>
                          </div>
                          <p>{item.valorPagamentosEfetuados}</p>
                        </div>
                        <div className="item-dinheiro">
                          <div className="historico-faturas__title-mobile">
                            <span className="title">Saldo devedor</span>
                          </div>
                          <p>{item.devedor}</p>
                        </div>
                        <div className="item-dinheiro btn-desktop">
                          <div className="historico-faturas__title-mobile">
                            <span className="title">Ações</span>
                          </div>
                          <DuplicatedInvoicePDFModal
                            invoiceId={item.idFatura}
                            dueDate={formatted_due_date}
                          />
                          <button
                            type="button"
                            onClick={() =>
                              onGetInvoicePdf(
                                item?.idFatura,
                                item?.dataVencimento?.split("/"),
                                client?.client?.cpf
                              )
                            }
                            disabled={!!loadingInvoiceIdPdf}
                          >
                            {loadingInvoiceIdPdf === item?.idFatura ? (
                              <LoadingElevaty
                                width="18px"
                                height="18px"
                                duration="durFast"
                                useSizeProps
                              />
                            ) : (
                              <MdOutlineDownload />
                            )}
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </span>
              </>
            ) : null}
          </div>
        )}
      </Style.WrapperModalHistoricoFaturas>
    </Modal>
  );
}

export default ModalHistoricoFaturas;
